// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__346So","importantInfo":"styles_importantInfo__1DZko"};